import { patientApi } from '@/api/PatientApi'
import { useQuery } from '@tanstack/react-query'

/** One submitted form with its answers. A submission never changes, so it is kept once read. */
const useFetchCompletedForm = (id: number | null) => {
	const { data, isLoading, isError, refetch } = useQuery({
		queryKey: ['completed-form', id],
		queryFn: () => patientApi.getCompletedForm(id as number),
		enabled: id !== null && Number.isFinite(id),
		staleTime: Number.POSITIVE_INFINITY,
	})

	return {
		completedForm: data,
		isLoading,
		isError,
		// Kept for ever once read, so the only reason to ask again is that the first ask failed —
		// which is exactly what the sheet's error state offers.
		refetch,
	}
}

export { useFetchCompletedForm }
